/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { run2  } from './Multiview';

run2(document.getElementById('viewer'));
